module.exports = __webpack_public_path__ + "img/icon-notice-9923fea9.svg";